import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './OriginalPost.css';
import TagList from '../Common/TagList';
import AdditionalUserInformation from './AdditionalUserInformation';
import HighlightToggle from '../Common/HighlightToggle';
import CommentContent from '../Common/CommentContent';
import commentHighlightingIcon from '../../images/comment_highlighting.svg';
import { logEvent } from '../../utils/Logger';
import exp from 'constants';
import { Sentence } from '../../types/types';
import {Tag as TagType} from '../../types/types';
import { usernames } from '../../data/highlightedUsernames';

interface TagMatch {
  text: string;
  tag: string;
}

interface OriginalPostProps {
  fetchedCommentData: any | null;
  id: string;
}

const OriginalPost: React.FC<OriginalPostProps> = ({ fetchedCommentData, id }) => {
  const [isHighlighted, setIsHighlighted] = useState(false);
  const navigate = useNavigate();

  const isCommentHighlighted = usernames.includes(fetchedCommentData.username);
  const isCommentHighlightedClass = isCommentHighlighted ? 'comment--highlighted' : '';     

  const handleHighlightToggle = () => {
    const eventName = isHighlighted ? 'disable_highlight' : 'enable_highlight';
    setIsHighlighted(!isHighlighted);

    const payload = {
      comment_id: id,
    }
    logEvent(eventName, JSON.stringify(payload), window.location.href);
  };

  const handleReplyClick = () => {
    logEvent('reply_click', JSON.stringify(fetchedCommentData), window.location.href);
    navigate(`/reply/${id}`, { 
      state: { 
        tags: fetchedCommentData.frames,
        content: fetchedCommentData.text,
        sentences: fetchedCommentData.sentences,
        title: fetchedCommentData.title
      } 
    });
  };

  const transformedTagMatch: TagMatch[] = fetchedCommentData.sentences.map(
    (sentence: Sentence) => ({
      text: sentence.text,
      tag: sentence.frame,
      explanation: sentence.explanation
    })
  );

  const [highlightedTag, setHighlightedTag] = useState<string>('');

  const onTagHover = (tag: TagType) => {
    const eventName = 'onTagHover';
    const payload = {
      comment_id: id,
      tag: tag.frame,
    }
    logEvent(eventName, JSON.stringify(payload), window.location.href);
    setHighlightedTag(tag.frame);
  }

  const onTagHoverOut = () => {
    const eventName = 'onTagHoverOut';
    const payload = {
      comment_id: id,
      tag: highlightedTag
    }
    logEvent(eventName, JSON.stringify(payload), window.location.href);
    setHighlightedTag('');
  }

  return (
    <div className={`original-post comment-placeholder ${isCommentHighlightedClass}`}>
      <div className="comment-header">
        <div className="user-info">
          <span className="username">{fetchedCommentData.username}</span>
          <TagList tags={fetchedCommentData.frames} onTagHover={onTagHover} onTagHoverOut={onTagHoverOut} />
        </div>
        <div className="header-right">
          <HighlightToggle isEnabled={isHighlighted} onToggle={handleHighlightToggle} />
          {/* <AdditionalUserInformation 
            explanation={fetchedCommentData.explanation}/> */}
        </div>
      </div>
      <div className={`comment-body`}>
        <h3 className="post-title">{fetchedCommentData.title}</h3>
        <CommentContent
          content={fetchedCommentData.text}
          tagMatch={transformedTagMatch}
          isHighlightEnabled={isHighlighted}
          highlightedFrame={highlightedTag}
        />
      </div>
      <button className="reply-button" onClick={handleReplyClick}>
        <img src={commentHighlightingIcon} alt="Reply" />
        Reply
      </button>
    </div>
  );
};

export default OriginalPost;